import { ProtectedJsonAPI } from './'

export const Themes = ProtectedJsonAPI.extend(
  '/themes',
  {
    index: endpoint => endpoint
  }
)